namespace $.$$ {

	$mol_style_define( $shm_echarts, {

		position: 'absolute',
		left: 0,
		top: 0,
		width: '100%',
		height: '100%',
		display: 'block',
		backgroundColor: 'transparent',

	} )

}
